import React from 'react';

const CustomChartTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
        return (
            <div style={{
                background: 'rgba(8, 8, 12, 0.85)',
                backdropFilter: 'blur(24px)',
                WebkitBackdropFilter: 'blur(24px)',
                border: '1px solid var(--primary-color)',
                borderRadius: '16px',
                padding: '16px 20px',
                boxShadow: '0 0 15px var(--primary-light, rgba(59, 130, 246, 0.5)), inset 0 0 5px var(--primary-light, rgba(59, 130, 246, 0.2))',
                minWidth: '180px',
                color: '#fff',
                fontFamily: "'Inter', sans-serif"
            }}>
                {/* Header / Label */}
                {label && (
                    <div style={{
                        fontSize: '0.9rem',
                        fontWeight: '700',
                        marginBottom: '12px',
                        borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
                        paddingBottom: '8px',
                        letterSpacing: '0.5px',
                        color: 'rgba(255, 255, 255, 0.9)'
                    }}>
                        {label}
                    </div>
                )}

                {/* Data Items */}
                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                    {payload.map((entry, index) => (
                        <div key={index} style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            fontSize: '0.85rem'
                        }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <div style={{
                                    width: '10px',
                                    height: '10px',
                                    borderRadius: '50%',
                                    backgroundColor: entry.color,
                                    boxShadow: `0 0 10px ${entry.color}80` // Glow effect
                                }}></div>
                                <span style={{ color: 'rgba(255, 255, 255, 0.7)' }}>{entry.name}:</span>
                            </div>
                            <span style={{ fontWeight: '700', color: '#fff' }}>
                                {entry.value}
                            </span>
                        </div>
                    ))}
                </div>
            </div>
        );
    }
    return null;
};

export default CustomChartTooltip;
